import { render } from "./App.vue?vue&type=template&id=6faa70a0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6faa70a0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user1\\project\\reghub\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faa70a0"]])

export default __exports__